import { numberToPrettyString } from '@cian/utils';

/**
 * Округление как `'%.0f' % value` в Python: половина округляется к чётному
 */
function roundHalfToEven(value: number): number {
  const floor = Math.floor(value);

  if (value - floor === 0.5) {
    return floor % 2 === 0 ? floor : floor + 1;
  }

  return Math.round(value);
}

/**
 * Целое число с разделителем тысяч. Порт `render_number` монолита (`cian/utils/helpers.py`)
 */
export function formatNumber(value: number | null | undefined): string {
  return numberToPrettyString(roundHalfToEven(value ?? 0));
}
